<div [formGroup]="highSchoolForm" class="parent-container">
    <div class="left-container">
        <div>
            <h4>School details</h4>
        </div>
        <div>
            <p>School name</p>
            <input pInputText formControlName="schoolName">
        </div>
        <div>
            <p>School phone number</p>
            <input pInputText formControlName="schoolPhone">
            <div class="global-warning"
                *ngIf="highSchoolForm.get('schoolPhone')!.touched && highSchoolForm.get('schoolPhone')!.errors!['invalidPhoneNumber']">
                Phone number not valid
            </div>
        </div>
        <div>
            <p>School address</p>
            <input pInputText formControlName="schoolAddress" class="address-input">
        </div>
        <div>
            <p>School city</p>
            <input pInputText formControlName="schoolCity">
        </div>
        <div>
            <p>School post code</p>
            <input pInputText formControlName="schoolPostCode">
        </div>
        <div>
            <p>School website</p>
            <input pInputText formControlName="schoolWebsiteUrl" class="url-input">
        </div>
        <div>
            <p>School e-mail</p>
            <input pInputText formControlName="schoolEmail" class="email-input">
            <div class="global-warning"
                *ngIf="highSchoolForm.get('schoolEmail')!.touched && highSchoolForm.get('schoolEmail')!.errors!['invalidEmail']">
                School email number not valid
            </div>
        </div>
    </div>
    <div class="middle-1-container">
        <div>
            <h4>Local coordinator</h4>
        </div>
        <div>
            <p>Local coordinator Name</p>
            <input pInputText formControlName="localCoordinatorName" class="person-name-input">
        </div>
        <div>
            <p>Local coordinator Phone number</p>
            <input pInputText formControlName="localCoordinatorPhone">
            <div class="global-warning"
                *ngIf="highSchoolForm.get('localCoordinatorPhone')!.touched && highSchoolForm.get('localCoordinatorPhone')!.errors!['invalidPhoneNumber']">
                Phone number not valid
            </div>
        </div>
        <div>
            <p>Local coordinator Email</p>
            <input pInputText formControlName="localCoordinatorEmail" class="email-input">
            <div class="global-warning"
                *ngIf="highSchoolForm.get('localCoordinatorEmail')!.touched && highSchoolForm.get('localCoordinatorEmail')!.errors!['invalidEmail']">
                Local coordinator email not valid
            </div>
        </div>
        <div>
            <h4>School coordinator</h4>
        </div>
        <div>
            <p>School coordinator name</p>
            <input pInputText formControlName="schoolCoordinatorName" class="person-name-input">
        </div>
        <div>
            <p>School coordinator phone number</p>
            <input pInputText formControlName="schoolCoordinatorPhone">
            <div class="global-warning"
                *ngIf="highSchoolForm.get('schoolCoordinatorPhone')!.touched && highSchoolForm.get('schoolCoordinatorPhone')!.errors!['invalidPhoneNumber']">
                Phone number not valid
            </div>
        </div>
        <div>
            <p>School coordinator Email</p>
            <input pInputText formControlName="schoolCoordinatorEmail" class="email-input">
            <div class="global-warning"
                *ngIf="highSchoolForm.get('schoolCoordinatorEmail')!.touched && highSchoolForm.get('schoolCoordinatorEmail')!.errors!['invalidEmail']">
                School coordinator email not valid
            </div>
        </div>
    </div>
    <div class="middle-2-container">
        <div>
            <h4>Partner Contact</h4>
        </div>
        <div>
            <p-dropdown placeholder="Select" [options]="schoolContactOptions" (onChange)="contactOptionChange()"
                formControlName="selectedContact"></p-dropdown>
        </div>
        <div *ngFor="let contact of selectedSchoolContacts">
            <p>Partner name</p>
            <p>{{contact.name}}</p>
            <p>Partner Phone number</p>
            <p>{{contact.phoneNumber}}</p>
            <p *ngIf="!contact.phoneNumber">/</p>
            <p>Partner Email</p>
            <p>{{contact.email}}</p>
            <p *ngIf="!contact.email">/</p>
            <p-button styleClass="p-button-danger" label="Delete" (onClick)="deleteContact(contact)"></p-button>
        </div>
        <div *ngFor="let form of contactFormArray.controls; let i = index">
            <div [formGroup]="form | formGroup">
                <div>
                    <div>
                        <p>
                            Type
                        </p>
                        <p-dropdown placeholder="---" [options]="schoolContactTypes" formControlName="contactType"
                            optionLabel="name"></p-dropdown>
                    </div>
                    <div>
                        <p>
                            Name
                        </p>
                        <input pInputText formControlName="contactName">
                    </div>
                </div>
                <div class="contact-form-item-container">
                    <div>
                        <p>
                            Email
                        </p>
                        <input pInputText formControlName="contactEmail" width="380">
                        <div class="global-warning"
                            *ngIf="form.get('contactEmail')!.touched && form.get('contactEmail')!.errors!['invalidEmail']">
                            Email not valid
                        </div>
                    </div>
                    <div>
                        <p>
                            Phone number
                        </p>
                        <input pInputText formControlName="contactPhoneNumber">
                        <div class="global-warning"
                            *ngIf="form.get('contactPhoneNumber')!.touched && form.get('contactPhoneNumber')!.errors!['invalidPhoneNumber']">
                            Phone number not valid
                        </div>
                    </div>
                </div>
                <p-button styleClass="p-button-danger" label="Delete" (onClick)="deleteContactForm(form)"></p-button>
            </div>
        </div>
        <p-button label="add custom contact" (onClick)="addSchoolContactForm()"></p-button>
    </div>
    <div class="right-container">
        <div>
            <h4>Other</h4>
        </div>
        <div>
            <p>General remarks / other information</p>
            <textarea pInputTextarea formControlName="comment" cols="34" rows="10"></textarea>
        </div>
    </div>
</div>